import { Title } from '@chillibean/component-library/legacy';
import PropTypes from 'prop-types';

import withHttpRequest from '../../../../hoc/withHttpRequest';

export function AssetTitle(props) {
  const { data = undefined, loading = false } = props;

  return <Title heading={data ? data.title : ''} subheading="Currently reviewing" loading={loading} />;
}

AssetTitle.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
  }),
  loading: PropTypes.bool,
};

export default withHttpRequest(AssetTitle, 'fetchAsset');
